export default {
  carton: 'Carton No: ',
  ao: 'AO: ',
  sku: 'SKU: ',
  skuTip: 'SKU',
  upc: 'UPC',
  nfcUid: 'NFC UID',
  clear: 'Clear',
  pleaseScan: 'Please scan',
  taggingAll: 'Must Tagging all Products',
  alreadyTag: 'NFC already tag',
  tagSuccess: 'Tag Success',
  cartonDoesNotExist: "Carton doesn't exist in the Wave Run list",
  skuDoesNotExist: "SKU doesn't exist in the Carton, please contact administrator",
  cartonAlreadyTag: 'Carton already tag',
  cartonDoesNotIncludeNFCSKU: "Carton doesn't include NFC SKU",
  errorcode_417: 'NFC Uid already exists',
  errorcode_419: 'Not NFC product!',
  errorcode_903: 'Must tagging all Products',
  errorcode_4171: 'NFC Uid must be unique',
  errorcode_439: 'Current client is not workstation PC',
  errorcode_433: "Param can't be empty",
  errorcode_416: "NFC Uid can't be empty",
  errorcode_901: "SKU doesn't exist in the Carton",
  errorcode_902: 'Cached product %s is not same',
  errorcode_604: 'The carton is cancelled in wave run list.',
  submit: 'Submit',
  hasAllTagged: 'Already bound',
  totalData: 'Total data: ',
  boundItems: 'Number of bound items: ',
  requiredTagType: 'Required Tag Type',
  actualTagType: 'Actual Tag Type',
  tagStatus: 'Tag Status',
  action: 'Action',
  salesOrder: 'Sales Order: ',
  productCode: 'Product Code'
}
